// extracted by mini-css-extract-plugin
module.exports = {"badge":"Default_badge__zrQ_A","leftIcon":"Default_leftIcon__p8Rai","inline":"Default_inline__xMxWg"};